import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faClock } from '@fortawesome/pro-regular-svg-icons';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'app-beta-notice-modal',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule],
  templateUrl: './beta-notice-modal.component.html',
  styleUrl: './beta-notice-modal.component.css',
})
export class BetaNoticeModalComponent {
  @Input() daysRemaining = 0;
  @Input() expired = false;

  @Output() close = new EventEmitter<void>();

  faClock = faClock;
  faXmark = faXmark;

  /** "en 7 días" / "mañana" / "hoy", según los días que falten. */
  get deadlineText(): string {
    if (this.daysRemaining <= 0) {
      return 'hoy';
    }
    if (this.daysRemaining === 1) {
      return 'mañana';
    }
    return `en ${this.daysRemaining} días`;
  }

  onClose(): void {
    this.close.emit();
  }
}
